import { gql } from 'apollo-angular';
import { ConnectedDevice } from '../../entities/connected-device/connected-device';

export const CONNECTED_DEVICE_QUERY = gql`
query getConnectedDevice(
  $id: UUID
)
{
  getConnectedDevice: getConnectedDevice(
    id: $id
  )
  {
    name
    id
    appVersion
    platform
    model
    osVersion
    manufacturer
    lastSeenDateTime
    user{
      id
      firstName
      lastName
    }
    createdDateTime
    updateState
    permissions
    androidSdk
    language
    locale
    debugDeviceUrl
  },
}
`;

export interface ConnectedDeviceQuery {
  getConnectedDevice: ConnectedDevice;
  loading: boolean;
}
